/* Proposte logo LB Trade Advisory — navy/oro/avorio.
   Ogni variante: <Mark96> (grande), <Lockup> (logo completo per navbar/footer).
   I componenti accettano `bg`: "dark" (su navy) o "light" (su avorio). */

const NAVY = "#071522";
const NAVY_LIGHT = "#102434";
const GOLD = "#b9a276";
const GOLD_BRIGHT = "#d8c08e";
const IVORY = "#f5f3ee";

/* ---------- A — SIGILLO: monogramma in doppio anello con testo curvo ---------- */
export function LogoA({ size = 96, bg = "dark" }) {
  const fg = bg === "dark" ? IVORY : NAVY;
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" role="img" aria-label="LB Trade Advisory">
      <circle cx="48" cy="48" r="45" stroke={GOLD} strokeWidth="2.5" />
      <circle cx="48" cy="48" r="37.5" stroke={GOLD} strokeWidth="1" opacity="0.75" />
      {[[48, 10.5], [48, 85.5], [10.5, 48], [85.5, 48]].map(([x, y], i) => (
        <rect key={i} x={x - 2.8} y={y - 2.8} width="5.6" height="5.6" fill={GOLD_BRIGHT} transform={`rotate(45 ${x} ${y})`} />
      ))}
      <text x="48" y="52.5" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="25" fontWeight="600" fill={fg} letterSpacing="2">LB</text>
      <path id="arcA" d="M 22 55 A 27 27 0 0 0 74 55" fill="none" />
      <text fontSize="6.4" letterSpacing="2.4" fill={GOLD} fontFamily="Arial, sans-serif">
        <textPath href="#arcA" startOffset="50%" textAnchor="middle">TRADE ADVISORY</textPath>
      </text>
    </svg>
  );
}

/* ---------- B — MERIDIANI: globo con LB al centro ---------- */
export function LogoB({ size = 96, bg = "dark" }) {
  const plate = bg === "dark" ? NAVY : IVORY;
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" role="img" aria-label="LB Trade Advisory">
      <circle cx="48" cy="48" r="45" stroke={GOLD} strokeWidth="2.5" />
      <ellipse cx="48" cy="48" rx="18" ry="45" stroke={GOLD} strokeWidth="1.1" opacity="0.65" />
      <ellipse cx="48" cy="48" rx="34" ry="45" stroke={GOLD} strokeWidth="1.1" opacity="0.4" />
      <line x1="3" y1="48" x2="93" y2="48" stroke={GOLD} strokeWidth="1.1" opacity="0.5" />
      <path d="M 9 27 Q 48 15 87 27" stroke={GOLD} strokeWidth="1.1" opacity="0.5" fill="none" />
      <path d="M 9 69 Q 48 81 87 69" stroke={GOLD} strokeWidth="1.1" opacity="0.5" fill="none" />
      <circle cx="48" cy="48" r="19" fill={plate} />
      <text x="48" y="54" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="19" fontWeight="600" fill={bg === "dark" ? IVORY : NAVY} letterSpacing="1.5">LB</text>
      <circle cx="48" cy="48" r="19" stroke={GOLD_BRIGHT} strokeWidth="1.4" />
    </svg>
  );
}

/* ---------- C — ROTTA: monogramma con rotta tratteggiata in ascesa ---------- */
export function LogoC({ size = 96, bg = "dark" }) {
  const fg = bg === "dark" ? IVORY : NAVY;
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" role="img" aria-label="LB Trade Advisory">
      <text x="30" y="56" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="34" fontWeight="600" fill={fg} letterSpacing="1">LB</text>
      <path d="M 16 70 Q 48 76 68 58 T 86 22" stroke={GOLD} strokeWidth="2.2" strokeDasharray="1 5" strokeLinecap="round" fill="none" />
      <circle cx="16" cy="70" r="3.2" fill={GOLD_BRIGHT} />
      <path d="M 80 20 L 89 18.5 L 84.5 26.5 Z" fill={GOLD_BRIGHT} />
      <path d="M 20 84 H 76" stroke={GOLD} strokeWidth="2.5" />
      <path d="M 20 84 L 20 80 M 76 84 L 76 80" stroke={GOLD} strokeWidth="2" />
    </svg>
  );
}

/* ---------- D — BUSSOLA ESAEDRICALE: esagono con ago della bussola ---------- */
export function LogoD({ size = 96, bg = "dark" }) {
  const fg = bg === "dark" ? IVORY : NAVY;
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" role="img" aria-label="LB Trade Advisory">
      <path d="M48 3 L86.3 25.5 V70.5 L48 93 L9.7 70.5 V25.5 Z" stroke={GOLD} strokeWidth="2.5" />
      <path d="M48 12 L79 30 V66 L48 84 L17 66 V30 Z" stroke={GOLD} strokeWidth="0.9" opacity="0.45" />
      <path d="M 48 26 L 54.5 44 L 48 39.5 L 41.5 44 Z" fill={GOLD_BRIGHT} />
      <path d="M 48 70 L 41.5 52 L 48 56.5 L 54.5 52 Z" fill={GOLD} opacity="0.8" />
      <text x="48" y="52.5" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="600" fill={fg} letterSpacing="2">LB</text>
    </svg>
  );
}

/* ---------- E — WORDMARK EDITORIALE: tipografia con rombo ---------- */
export function LogoE({ size = 96, bg = "dark" }) {
  const fg = bg === "dark" ? IVORY : NAVY;
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" role="img" aria-label="LB Trade Advisory">
      <rect x="14" y="10" width="68" height="76" stroke={GOLD} strokeWidth="2" />
      <rect x="18.5" y="14.5" width="59" height="67" stroke={GOLD} strokeWidth="0.8" opacity="0.5" />
      <text x="48" y="43" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="27" fontWeight="600" fill={fg} letterSpacing="3">LB</text>
      <rect x="30" y="50" width="36" height="1.4" fill={GOLD} />
      <text x="48" y="63" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="6.2" letterSpacing="2.6" fill={GOLD}>TRADE</text>
      <text x="48" y="72" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="6.2" letterSpacing="2.6" fill={GOLD}>ADVISORY</text>
      <rect x="44.6" y="79.5" width="6.8" height="6.8" fill={GOLD_BRIGHT} transform="rotate(45 48 82.9)" />
    </svg>
  );
}

/* ---------- Lockup completo (mark + wordmark orizzontale) ---------- */
export function Lockup({ Logo, compactSize = 30, bg = "dark", textColor }) {
  const color = textColor || (bg === "dark" ? IVORY : NAVY);
  return (
    <span className="inline-flex items-center gap-3">
      <Logo size={compactSize} bg={bg} />
      <span className="flex flex-col leading-none">
        <span style={{ color, fontFamily: "'Playfair Display', Georgia, serif", fontSize: 19, fontWeight: 600, letterSpacing: 1 }}>
          LB <span style={{ color: bg === "dark" ? GOLD_BRIGHT : "#8a744a" }}>Trade Advisory</span>
        </span>
        <span style={{ color: bg === "dark" ? "rgba(245,243,238,0.5)" : "#5b6b78", fontFamily: "Arial, sans-serif", fontSize: 8, letterSpacing: 4.2, marginTop: 3 }}>
          CONSULENZA COMERCIO INTERNAZIONALE
        </span>
      </span>
    </span>
  );
}
